export default __webpack_public_path__ + "img/favicons/apple-touch-icon-180x180.png";